const handle = "lorenakauaneph"

const links = [
  {
    label: "Github",
    component: "Github",
    url: `https://github.com/LorenaKauane`,
  },
  {
    label: "Linkedin",
    component: "LinkedinWithCircle",
    url: `https://www.linkedin.com/in/lorena-porphirio/`,
  },
  {
    label: "Instagram",
    component: "InstagramWithCircle",
    url: `https://www.instagram.com/${handle}`,
  },
  {
    label: "Medium",
    component: "MediumWithCircle",
    url: "https://medium.com/@lorenakauane",
  },
]

export default links
